// extracted by mini-css-extract-plugin
var _1 = "FavoriteIcon_active__e3e74";
var _2 = "FavoriteIcon_root__d2f64";
export { _1 as "active", _2 as "root" }
